var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.rootClassName},[_c('div',{class:_vm.$style.content},[_vm._t("default")],2),_vm._v(" "),(_vm.hasFooter)?_c('div',{class:_vm.$style.footer},[_vm._t("footer")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }